export class WhoAmI{
    userName: string;
    avatarUrl: string;
    email: string;
}

export class TokenData{
    constructor(oauthToken: string, refreshToken: string) {
        this.oauthToken = oauthToken
        this.refreshToken = refreshToken
    }

    oauthToken: string;
    refreshToken: string;
}
export interface AuthState {
    oauthToken: string;
    refreshToken: string;
    isAuthenticated: boolean;
    hasLoadedOnce: boolean;
}
export default {
    namespaced: true,
    state: {
        oauthToken: localStorage.getItem('jwt') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        isAuthenticated:false,
        hasLoadedOnce: false,
        whoAmI: new WhoAmI(),
    } as AuthState,
    getters: {
        isAuthenticated(state) {
            return Boolean(state.oauthToken);
        },
        getAuthToken(state){
            return state.oauthToken;
        },
        getRefreshToken(state){
            return state.refreshToken;
        },
        getWhoAmI(state){
            return state.whoAmI;
        }
    },
    mutations: {
        SET_TOKEN(state, tokenData: TokenData) {
            state.oauthToken = tokenData.oauthToken;
            state.refreshToken = tokenData.refreshToken;
            state.isAuthenticated = true;
            state.hasLoadedOnce = true;
        },
        CLEAR_TOKEN(state) {
            state.oauthToken = '';
            state.isAuthenticated = false;
            state.hasLoadedOnce = false;
        },
        ADD_WHOAMI(state, info: WhoAmI){
            state.whoAmI = info;
        }
    },
    actions: {
        setToken({ commit },  payload: {tokenData: TokenData} ) {
            localStorage.setItem('jwt',payload.tokenData.oauthToken);
            localStorage.setItem('refreshToken', payload.tokenData.refreshToken)
            commit('SET_TOKEN', payload.tokenData)
        },
        clearToken({ commit }, token: string) {
            commit('CLEAR_TOKEN');
        },
        addWhoIsInformation({ commit },  payload: {userInfo: WhoAmI} ) {
            commit('ADD_WHOAMI', payload.userInfo);
        },
        /*
        async loadName({ commit }, payload: { id: string }) {
            const name = `Name-${payload.id}` // load it from somewhere
            commit("SET_NAME", name)
            return { name }
        },*/
    }
} as const;
